import { normalizeGrade } from '../lib/gradeUtils'
import { getPlayerGrade } from '../lib/localStorage'
import { TEACHER_WORDS } from '../teacherWords'

const grade = normalizeGrade(getPlayerGrade())
const nogradeyet = ['error']

let GRADEWORDS = nogradeyet

// Fall 2026 rollover — Class of 2027 (was Junior list), Class of 2028 (was
// Sophomore list), Class of 2029 (was Freshman list) promoted up one grade
// each; Class of 2030 added fresh. Source: updated school directory export,
// same one used for the Supabase roster sync (migrations 008/009).
const SENIOR = [
  'emerson',
  'william',
  'mitchell',
  'rhodes',
  'daniel',
  'brooke',
  'avery',
  'harris',
  'grant',
  'madeline',
  'cesar',
  'gavin',
  'davis',
  'margot',
  'hotoniel',
  'jack',
  'sam',
  'robby',
  'margaret',
  'gigi',
  'christina',
  'emmy',
  'felipe',
  'florencia',
  'grey',
  'claire',
  'caroline',
  'hailey',
  'ryan',
  'jackson',
  'aj',
  'amara',
  'jon miller',
  'anaya',
  'patrick',
  'juliana',
  'nicholas',
  'finn',
  'connor',
  'andrew',
  'ella',
  'emma',
  'kate',
  'mary',
  'brendan',
  'joselyn',
  'mateo',
  'eliana',
  'graham',
  'nora',
  'will',
  'tuck',
  'amaree',
  'phillip',
  'maxx',
  'betsy',
  'sophie',
  'cole',
  'alexa',
  'sammy',
  'sidney-ann',
  'blair',
  'evelyn grace',
  'gracie',
  'ayokunle',
  'meriwether',
  'paige',
  'ria',
  'amelia',
  'hannah',
  'katlynn',
  'teagan',
  'beatrice',
  'sarah',
  'vance',
  'hunter',
  'brad',
  'tyler',
  'greg',
  'franklin',
  'braiden',
  'annabelle',
  'preston',
  'maddie',
  'tommy',
  'collier',
  'colt',
  'dean',
  'havana',
  'matthew',
  'lily',
  'kade',
  'griffin',
  'hayes',
  'mose',
  'vandy',
  'logan',
  'scarlett',
  'mcvey',
  'george',
  'chloe',
  'luke',
  'layla',
  'ryder',
  'ray',
  'victoria',
  'mayomi',
  'maya',
  'bryce',
  'sienna',
  'grace',
  'bobby',
  'charlie',
  'lilah',
  'sean',
  'kenzo',
  'leah',
  'jules',
  'gabriella',
  'charlotte',
  'sasha',
  'sophia',
  'tanner',
  'marley',
  'eva marie',
  'brent',
  'chase',
  'harley',
  'makayla',
  'grayson',
  'christian',
  'nicole',
]

const JUNIOR = [
  'andrew',
  'madison',
  'brayden',
  'jason',
  'xavier',
  'quinn',
  'madeline',
  'strickland',
  'ingrid',
  'aaniyah',
  'jackson',
  'karissa',
  'zoe',
  'bennett',
  'nicholas',
  'will',
  'cole',
  'bailey',
  'fisher',
  'ronan',
  'bentley',
  'lucas',
  'eden',
  'bree',
  'eva',
  'mackenzie',
  'liam',
  'lane',
  'hudson',
  'thomas',
  'ryan',
  'ellison',
  'garrett',
  'brody',
  'dyer',
  'wyatt',
  'marshall',
  'bryce',
  'grayden',
  'emily',
  'sam',
  'jackie',
  'lila',
  'elizabeth',
  'lydia',
  'davis',
  'teddy',
  'violet',
  'carson',
  'samantha',
  'sky',
  'bella',
  'sloane',
  'martin',
  'landen',
  'cooper',
  'cathryn-rose',
  'mary-grace',
  'cristiano',
  'whitney',
  'addison',
  'charlie',
  'peighton',
  'mary brooks',
  'julia-pun',
  'crosby',
  'gemma',
  'sophia',
  'townsend',
  'belle',
  'alexa',
  'merrick',
  'landon',
  'loriel',
  'connor',
  'bobby',
  'ayden',
  'maia',
  'emme',
  'jonah',
  'caroline',
  'lucy',
  'turner',
  'grant',
  'ava',
  'kaylee',
  'riley',
  'daniel',
  'logan',
  'jude',
  'sarah',
  'maddie',
  'molly',
  'aspen',
  'jack',
  'shane',
  'miller',
  'aubrey',
  'gabby',
  'bryson',
  'allison',
  'makenzie',
  'adair',
  'george',
  'wilkins',
  'treasure',
  'ashley',
  'colt',
  'divya',
]

const SOPHOMORE = [
  'sophie',
  'king',
  'ben',
  'teddy',
  'graham',
  'aaron',
  'morgan',
  'finn',
  'amzie',
  'madeline',
  'cole',
  'krystin',
  'natalie',
  'blakely',
  'jacob',
  'henry',
  'kate',
  'robert',
  'chris',
  'byrdie',
  'mason',
  'fiver',
  'sam',
  'noah',
  'zachary',
  'ken ken',
  'ryan',
  'sawyer',
  'braeden',
  'khloe',
  'hudson',
  'cannon',
  'addie',
  'harrison',
  'gus',
  'banks',
  'hardy',
  'ella',
  'matthew',
  'alessandra',
  'yovela',
  'asher',
  'joey',
  'caroline',
  'nandi',
  'william',
  'ellie',
  'ridge',
  'daniel',
  'temma',
  'ollie',
  'katie',
  'colin',
  'breanna',
  'ellison',
  'parks',
  'joe',
  'nicholas',
  'jake',
  'trey',
  'xavi',
  'lila',
  'samantha',
  'kaleb',
  'penny',
  'melina',
  'bates',
  'miller',
  'jack',
  'ransom',
  'eve',
  'gracie',
  'callan',
  'finley',
  'sanders',
  'hannah',
  'catherine',
  'fernando',
  'aidan',
  'amariah',
  'mark',
  'chelsea',
  'ireland',
  'caden',
  'parker',
  'melanie',
  'auldyn',
  'luke',
  'camille',
  'christian',
  'isabelle',
  'kennedy',
  'alice',
  'truman',
  'ava',
  'haiden',
  'mack',
  'bobby',
  'liam',
  'aria',
  'xavier',
  'adrianna',
  'thomas',
  'rylee',
  'beckett',
  'harry',
  'liza',
  'hattie',
  'bella',
  'sydney',
  'mary drew',
]

const FRESHMAN = [
  'arafen',
  'tyler',
  'harper',
  'mary virginia',
  'abbey',
  'emma',
  'eidan',
  'nate',
  'alaina',
  'camille',
  'talan',
  'hailey',
  'brayden',
  'jd',
  'chandler',
  'ivana',
  'sally',
  'vinny',
  'virran',
  'cam',
  'andrew',
  'jade',
  'gabby',
  'finn',
  'ross',
  'wilder',
  'sydney',
  'mary kathryn',
  'jax',
  'spencer',
  'blake',
  'liam',
  'adonai',
  'abrielle',
  'josiah',
  'isabel',
  'wendy',
  'deuce',
  'abby',
  'caroline',
  'chori',
  'sam',
  'ella',
  'katherine',
  'neilan',
  'megan',
  'ridge',
  'sloane',
  'ben',
  'grayson',
  'tillan',
  'charles',
  'jacaria',
  'jimi',
  'connor',
  'luka',
  'jace',
  'anna',
  'yardley',
  'ilianna',
  'teddy',
  'aleka',
  'whitfield',
  'betsy',
  'dylan',
  'matthew',
  'ruby',
  'ryder',
  'lorelei',
  'wesley',
  'mason',
  'max',
  'idey',
  'william',
  'allison',
  'laney kate',
  'abe',
  'hazel',
  'wells',
  'tommy',
  'henry',
  'constanza',
  'blair',
  'jahmai',
  'aiden',
  'kayla',
  'daniel',
  'daria',
  'nola',
  'sandifer',
  'daniella',
  'lila',
  'sophia',
  'iris',
  'ava',
  'casey',
  'niagrace',
  'lanier',
  'daley',
  'drew',
  'shivani',
  'gabe',
  'mae',
  'cassandra',
  'robert',
  'austin',
  'jackie',
  'jane',
  'klyce',
  'agustin',
  'marlin',
  'tison',
  'holman',
  'harrison',
  'davis',
  'will',
  'avery',
  'fraser',
  'mia',
  'tiger',
  'kimora',
]

if (grade === '0') {
  GRADEWORDS = TEACHER_WORDS
} else if (grade === '') {
  GRADEWORDS = JUNIOR // Default for no grade set
} else if (grade === '12') {
  GRADEWORDS = SENIOR
} else if (grade === '11') {
  GRADEWORDS = JUNIOR
} else if (grade === '10') {
  GRADEWORDS = SOPHOMORE
} else if (grade === '9') {
  GRADEWORDS = FRESHMAN
} else {
  GRADEWORDS = nogradeyet
}

export const WORDS = GRADEWORDS

// Filtered word list for daily puzzle selection: skip names that are too short
// to make a good puzzle (2-3 letters like "jb", "jay", "rio", "mac").
// The full WORDS list is still used for guess validation so those names remain guessable.
export const DAILY_WORDS = GRADEWORDS.filter(
  (w) => w.replace(/-/g, '').replace(/ /g, '').length >= 4
)

// Export all grade arrays for use in grade-picker rounds
export { SENIOR, JUNIOR, SOPHOMORE, FRESHMAN }
